import * as tslib_1 from "tslib";
import { ValueField } from './value_fields';
var DateBox = /** @class */ (function (_super) {
    tslib_1.__extends(DateBox, _super);
    function DateBox(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'parseFormats';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    DateBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "DateBox",
            "parseFormats": this.parseFormats
        });
    };
    DateBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DateBox;
}(ValueField));
export { DateBox };
//# sourceMappingURL=date_box.js.map